// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2L_q0","content":"styles_content__F1Vux","checkbox":"styles_checkbox__3PV_D","checkboxLabel":"styles_checkboxLabel__1m7En"};